import React from "react";
import "./about.css";
import banner from "assets/images/banner/about-banner.webp";
import unsere from "assets/images/about/unsere-mission.webp";
import whatweoffer from "assets/images/about/whatweoffer.webp";
import legal from "assets/images/about/legal_image.webp";
import whois from "assets/images/about/whois.webp";
import Footer from "ThemeLayout/footer";
import { Link } from "react-router-dom";
const about = () => {
  return (
    <div className="aboutMain">
      <div
        className="aboutBanner"
        style={{ backgroundImage: `url(${banner})` }}
      >
        <div className="container">
          <div className="text-center p-4">
            <h1>About Us</h1>
          </div>
        </div>
      </div>

      <div className="aboutBreif">
        <div className="container">
          <div className="aboutBreif_inner">
            <h2>Welcome to Big Barrister</h2>
            <p>
              Your reliable online portal for information on penalties,
              offenses, and legal consequences. We offer you fast, discreet, and
              understandable information on criminal law topics so you're always
              well informed.
            </p>
          </div>
        </div>
      </div>

      <div className="ourServices">
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-lg-4">
              <div className="ourServices_grid">
                <div className="ourServices_grid_icon">
                  <img
                    src={unsere}
                    className="img-fluid"
                    alt="Unsere Mission"
                    title="Unsere Mission"
                    width="600"
                    height="300"
                  />
                </div>
                <div className="ourServices_grid_content">
                  <h2>Our Mission</h2>
                  <div className="ourServices_grid_content_in">
                    <p>
                      Our goal is to bring transparency to the complex subject
                      of criminal law. Whether it concerns fines, driver's
                      license suspensions, criminal records, or other sanctions
                      – we provide you with clear and easy-to-understand
                      information.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 border-start border-end border-3">
              <div className="ourServices_grid">
                <div className="ourServices_grid_icon">
                  <img
                    src={whatweoffer}
                    className="img-fluid"
                    alt="Was wir bieten"
                    title="Was wir bieten"
                    width="600"
                    height="300"
                  />
                </div>
                <div className="ourServices_grid_content">
                  <h2>What we offer</h2>
                  <div className="ourServices_grid_content_in">
                    <ul>
                      <li>
                        <b>Online queries</b>: Check quickly and easily what
                        penalties may apply in certain cases.
                      </li>
                      <li>
                        <b>Legal information</b>: Understandable explanations of
                        laws, judgments and procedures.
                      </li>
                      <li>
                        <b>Anonymity & data protection</b>: Your inquiries are
                        safe and completely confidential with us.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="ourServices_grid">
                <div className="ourServices_grid_icon">
                  <img
                    src={whois}
                    className="img-fluid"
                    alt="whois.webp"
                    title="whois.webp"
                    width="600"
                    height="300"
                  />
                </div>
                <div className="ourServices_grid_content">
                  <h2>Who is Big Barrister for?</h2>
                  <div className="ourServices_grid_content_in">
                    <p>
                      Our platform is aimed at private individuals, companies,
                      and professionals who want to learn about the legal
                      consequences. Whether you want to protect yourself or need
                      professional advice, we'll help you gain clarity.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="ourClaim">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <div className="ourClaim_img">
                <img
                  src={legal}
                  className="img-fluid"
                  alt=" Unser Anspruch"
                  title=" Unser Anspruch"
                  width="650"
                  height="400"
                />
              </div>
            </div>
            <div className="col-md-6 ps-md-5">
              <div className="ourClaim_content">
                <h2>Our claim</h2>
                <p>
                  We value up-to-date, verified, and understandable information.
                  Our team of legal experts and specialist authors ensures that
                  you receive reliable and practical answers.
                </p>
                <p>
                  Do you have any questions or need further information? Contact
                  us – we'll be happy to help!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default about;
